module.exports = __webpack_public_path__ + "media/country_flags/pe-a9116b07.png";